import { render, staticRenderFns } from "./YearsRanking.vue?vue&type=template&id=08607b10&scoped=true&"
import script from "./YearsRanking.vue?vue&type=script&lang=js&"
export * from "./YearsRanking.vue?vue&type=script&lang=js&"
import style0 from "./YearsRanking.vue?vue&type=style&index=0&id=08607b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08607b10",
  null
  
)

export default component.exports